export const defaultHttpTranslations = {
  //400
  STATUS_400_TITLE: 'Bad Request',
  STATUS_400_DESCRIPTION: 'Your request could not be processed. Please review the details and try again.',
  //401
  STATUS_401_TITLE: 'Unauthorized',
  STATUS_401_DESCRIPTION: 'Access denied. Please log in to continue.',
  //402
  STATUS_402_TITLE: 'Payment Required',
  STATUS_402_DESCRIPTION: 'Payment information is required to proceed. Please check your billing details.',
  //403
  STATUS_403_TITLE: 'Forbidden',
  STATUS_403_DESCRIPTION: 'You do not have the necessary permissions to access this resource.',
  //404
  STATUS_404_TITLE: 'Not Found',
  STATUS_404_DESCRIPTION: 'The requested resource was not found. It may have been moved or no longer exists.',
  //405
  STATUS_405_TITLE: 'Method Not Allowed',
  STATUS_405_DESCRIPTION: 'The requested action is not supported. Please check and try again.',

  STATUS_4XX_CATCH_ALL_ERROR_TITLE: 'Request Error',
  STATUS_4XX_CATCH_ALL_ERROR_DESCRIPTION:
    'We could not complete your request. Please check the details carefully and try again.',

  //500
  STATUS_500_TITLE: 'Internal Server Error',
  STATUS_500_DESCRIPTION: 'An unexpected issue occurred on our end. Please try again shortly.',
  //501
  STATUS_501_TITLE: 'Not Implemented',
  STATUS_501_DESCRIPTION: 'This feature is not currently supported.',
  //502
  STATUS_502_TITLE: 'Bad Gateway',
  STATUS_502_DESCRIPTION: 'We received an invalid response from an upstream service. Please try again.',
  //503
  STATUS_503_TITLE: 'Service Unavailable',
  STATUS_503_DESCRIPTION: 'The service is temporarily unavailable. Please try again later.',
  //504
  STATUS_504_TITLE: 'Gateway Timeout',
  STATUS_504_DESCRIPTION: 'The request took too long to process. Please check your connection and retry.',
  //505
  STATUS_505_TITLE: 'HTTP Version Not Supported',
  STATUS_505_DESCRIPTION:
    'Your request is using an unsupported HTTP version. Please contact customer support.',

  STATUS_5XX_CATCH_ALL_ERROR_TITLE: 'Service Error',
  STATUS_5XX_CATCH_ALL_ERROR_DESCRIPTION:
    'We encountered an issue processing your request. Please try again.',
};
